// constants

import { ApplicationStatus } from '@/store/enums';
import i18n from 'i18next';

export const InterviewFilterCategory = {
  scheduled: 'scheduled',
};

export const ApplicationStatusOptions = [
  {
    value: 1,
    label: i18n.t('agentsDetails.appStatusOptions.incompleteApplication'),
  },
  {
    value: 2,
    label: i18n.t('agentsDetails.appStatusOptions.applicationSubmitted'),
  },
  {
    value: 4,
    label: i18n.t('agentsDetails.appStatusOptions.newApplicant'),
  },
  {
    value: 5,
    label: i18n.t('agentsDetails.appStatusOptions.inviteInterview'),
  },
  {
    value: 8,
    label: i18n.t('agentsDetails.appStatusOptions.interviewReview'),
  },
  {
    value: 10,
    label: i18n.t('agentsDetails.appStatusOptions.inviteTraining'),
  },
];

export const disabledStatusList = [
  ApplicationStatus.RegisteredforTraining,
  ApplicationStatus.RescheduleClass,
  ApplicationStatus.CompletedTraining,
  ApplicationStatus.PassedTraining,
  ApplicationStatus.InterviewScheduled,
  ApplicationStatus.RescheduleInterview,
];
export const SpeedTestSessionKey = 'speed-test-redirect';
